import React, { Component } from 'react'
// import DataGrid from './DataGrid'
// import AllBlog from '../windows/Applets/database/AllBlog'
import CustomLoader from './CustomLoader'
import Responsive from './Responsive'
import { checkTranslation, getObject, imageAddress, priceStandardView, translate } from '../utils/useful'
import tableComponents from './tableComponents'
import moment from 'jalali-moment'
import { actionsData } from '../variables/actionsData'
import WidgetComponents from './widgets/WidgetComponents'
import CardRenderer from './CardRenderer'


export default class CardViewer extends Component {
    state = {

        ads: [
            { src: '/images/video/vid8.jpg' }
        ],

        fullUrl: [
            { href: '#' }
        ],
        headers: [],
        tempData: {}

    }


    componentDidMount() {
        // console.log('props====', this.props)
        this.init()
    }


    componentDidUpdate(prevProps) {

        // console.log(this.props.view?.settings)
        if (this.props.view?.settings?.cardInfo != this.state.cardInfo) {
            this.init()
        }

       
    }



    init() {

        this.setState({ cardInfo: this.props.view?.settings?.cardInfo })
        // let mainHeaders = this.props.headers ? [...this.props.headers] : []
        // let headers = []
        // // let headersKey = Object.keys(this.props.headersData)
        // // headers = headers.filter(header => headersKey.includes(header.key))
        // mainHeaders.forEach(header => {
        //     let valid = getObject(this.props.headersData, header.key) ?? getObject(this.props.headersData, ('**files.' + header.key), 1) ?? false
        //     if (valid) {
        //         // header.information.disabled = true
        //         headers.push(header)
        //     }
        // })
        // this.setState({ headers, show: false }, () => {
        //     this.setState({ show: true })
        // })


        let cardElements = []
        let content = this.props.view?.settings?.cardInfo



        // if (cardInfo && Array.isArray(cardInfo)) {
        //     cardInfo.forEach((element, index) => {
        //         cardElements.push(element)
        //     });
        // }

        // console.log(JSON.stringify(content))

        this.setState({ content })
    }


  


    textVariableReplacer = (data, content) => {

        if (content) {

            let output = content

            // console.log("HERE")
            // for (const [key, value] of Object.entries(filter)) {
            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)

            // matches.forEach((match,i) => {

            for (let index = 0; index < matches.length; index++) {
                const match = matches[index];


                let key = match.replace(/{/g, '').replace(/}/g, '')

                for (let j = 0; j < this.props.headers.length; j++) {
                    const header = this.props.headers[j];


                    // this.props.headers?.forEach(header => {
                    // let value
                    if (key == header.information?.label || key == header.key) {


                        // if (key == header.information?.label) {
                        //     value = header.information?.label
                        // }

                        // if (value == null && key == header.key) {
                        let value = getObject(data, header.key)
                        // }

                        switch (header.type) {
                            case "PriceInput":
                                value = priceStandardView(value)
                                break;

                            case "NumberInput":
                                value = priceStandardView(value)
                                break;

                            case "DateInput":
                                let format = 'DD MMM YYYY'
                                if (header.information?.showHour) {
                                    format = format + ' hh:mm'
                                }
                                if (moment(Number(this.props.data)).isValid()) {

                                }
                                value = moment(Number(value)).format(format)
                                break;

                            default:
                                break;
                        }


                        let nreg = new RegExp(match, 'g')

                        output = output.replace(nreg, value)

                        // console.log(output)
                        // return output
                    }


                }
            }

            return output

        }

    }

    // componentDidMount() {
    //     let fullUrl = siteConfig.rootDomain + Router.router.asPath

    //     // console.log(fullUrl)
    //     this.setState({ fullUrl })
    // }


    // actionClicked = (prop, data, index) => {

    //     console.log(prop, data, index)

    //     let stageList = ['sendTo']
    //     if (stageList.includes(prop.key)) {
    //         let cIndex = stageList.indexOf(prop.key)
    //         this.stageManager.changeStage(stageList[cIndex])
    //     }
    //     else {
    //         this.functionsHandler(prop, data, index)
    //     }

    // }

    actionClickedInRow = (prop, rowData, index, extra) => {
        this.selectedRowData = rowData
        this.selectedRowIndex = index

        // console.log(prop)
        // console.log(rowData)

        this.actionClicked(prop, extra)
    }


    actionClicked = (prop, extra) => {

        // console.log(prop, extra)

        if (typeof prop.function == 'function') {
            prop.function(this.selectedRowData, this.selectedRowIndex)
        } else {
            if (this.props[prop.function]) {
                this.props[prop.function](this.selectedRowData, this.selectedRowIndex, prop)
            } else {

                let myExtra = extra
                if (typeof extra == 'object') {
                    myExtra = extra ? { ...extra } : {}
                    myExtra.index = this.selectedRowIndex
                }

                // console.log(extra)
                // return
                this.props.functionsHandler('frame', prop.function, this.selectedRowData, myExtra, prop)
            }
        }
        // this.actionsModal.hideModal()
    }


    // functionsHandler = (prop, data, index) => {
    //     if (typeof prop.function == 'function') {
    //         // console.log('herefunc5')
    //         prop.function(data, this.selectedRowIndex)
    //     } else {
    //         console.log(prop.function)
    //         if (this.props[prop.function]) {
    //             // console.log('herefunc')
    //             this.props[prop.function](data, index, prop)
    //         } else {
    //             // console.log('herefunc2', prop, index)
    //             this.props.functionsHandler('collection', prop.function, data, index, prop)
    //         }
    //     }
    // }


    componentSelected = () => {

    }


    renderDiv = (section, parents, index, rowChildrenCount, columnChildrenCount, fullData) => {



        if (Array.isArray(section?.children)) {

            let rowDropables = [
                { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: '#007aff10' },
                // { key: 'left', left: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },
                // { key: 'left', right: 0, width: 10, top: 0, height: '100%', backgroundColor: '#ee505010' },

            ]

            let columnDropables = [
                // { key: 'top', left: 0, width: '100%', top: 0, height: 10, backgroundColor: '#007aff10' },
                // { key: 'bottom', left: 0, width: '100%', bottom: 0, height: 10, backgroundColor: '#007aff10' },
                { key: 'left', left: 0, width: 5, top: 0, height: '100%', backgroundColor: '#7a00ff10' },
                { key: 'right', right: 0, width: 5, top: 0, height: '100%', backgroundColor: '#7a00ff10' },

            ]

            let style = section.style ?? {}


            return (
                <div key={section.id} className={'position-relative  ' + (section.id) + (section.type == 'row' ? ' section-row d-flex' : ' section-column')} style={{ width: style.width ? (style.width + (style.widthUnit ?? '%')) : '100%', maxWidth: style.maxWidth ? (style.maxWidth + (style.maxWidthUnit ?? '%')) : null, padding: style.padding ?? null, background: style.background, boxShadow: style.boxShadow, margin: style.margin, borderRadius: style.borderRadius, border: this.state.isDraging ? "1px dashed #ddd" : '1px solid transparent', minHeight: 12 }} >
                    {section?.children.map((element, eIndex) => {

                        let newParents = [...parents]
                        newParents.push({ id: section.id, type: section.type, style: section.style })
                        // console.log(newParents)
                        return (
                            this.renderDiv(element, [...newParents], eIndex, (section.type == 'row' ? section?.children?.length : rowChildrenCount), (section.type == 'column' ? section?.children?.length : columnChildrenCount), fullData)
                        )
                    })}


                    {this.state.isDraging && section.type == 'row' && !section.temp && rowDropables.map((dropable, dIndex) => {
                        return (
                            <div key={dIndex} className={'dragable '} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'row', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 1, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                            </div>
                        )
                    })}



                    {this.state.isDraging && section.type == 'column' && !section.temp && columnDropables.map((dropable, dIndex) => {
                        return (
                            <div key={dIndex} className={'dragable '} onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: 'column', parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ zIndex: 1, position: 'absolute', top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                            </div>
                        )
                    })}



                </div>
            )

        } else {
            if (section.type == 'dropZone') {
                return (
                    <div key={section.id} className='p-1' style={{ flex: 12, pointerEvents: 'none' }} >
                        <div className='dropZone' style={{ borderRadius: 4, minHeight: 30, backgroundColor: '#007aff10', border: '1px solid #007aff' }}>
                            {/* <p>Ghost</p> */}
                        </div>
                    </div>
                )
            } else {

                let dropables = []

                let colStyle = Array.isArray(section.parents) ? (section.parents[section.parents?.length - 1]?.style ?? {}) : {}

                if (rowChildrenCount > 1) {
                    dropables.push({ key: 'bottom', left: 0, width: '100%', bottom: 0, height: 20, backgroundColor: '#ee505010' },)
                    dropables.push({ key: 'top', left: 0, width: '100%', top: 0, height: 20, backgroundColor: '#ee505010' })
                }

                if (columnChildrenCount > 1) {
                    dropables.push({ key: 'left', left: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: '#ee505010' },)
                    dropables.push({ key: 'right', right: 0, width: 20, top: 0, height: '100%', zIndex: 1, backgroundColor: '#ee505010' },)
                }




                // let Component = this.props.componentsInfo[section.type]?.components
                let Component = WidgetComponents[section.type] ?? null

                // console.log(section.type)
                // console.log(Component)
                let data = section?.information
                let header = section ?? { key: section.id, id: section.id, information: {} }
                // console.log(Component)
                if (!header.information) {
                    header.information = {}
                }
                section.parents = parents

                // console.log(Component)
                // console.log(section.type)

                // console.log(this.props.componentsInfo)

                return (
                    <div key={section.id}

                        // className={'element position-relative d-flex ' + "mb-1 p-1  col-lg-" + (data.col ?? "4 ") + (" col-md-" + (data.col <= 6 ? '6 ' : data.col)) + (" col-" + (data.col <= 3 ? '6 ' : '12 '))} style={{ flex: 12, minHeight: 40 }} >
                        // className={'element position-relative h-100 d-flex ' + "mb-1 p-1  col-lg-" + (data.col ?? "12 ") + (" col-md-" + (data.col <= 6 ? '6 ' : data.col)) + (" col-" + (data.col <= 3 ? '6 ' : '12 '))} style={{ flex: 12, minHeight: 40 }} >
                        className={'element w-100 position-relative flex-1 d-flex ' + " mb-0 p-0  "} style={{ flex: 12, minHeight: 12 }} >

                        {/* {!this.props.userView && this.state.selectedSection?.id == section.id && (
                            <div className='h-100 w-100 px-2 d-flex pb-2' style={{ position: 'absolute', top: 0, left: 0, zIndex: 3, alignItems: 'flex-end', justifyContent: 'flex-end', pointerEvents: 'none' }}>
                                <div className='builder-options-container flexc '>
                                    <img draggable={false} onMouseDown={(e) => { e.stopPropagation(); this.startMove(e, section) }} src='/assets/icons/drag-and-drop.svg' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.showConfig() }} src='/assets/icons/useful/settings.png' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.duplicateElement(section, parents, rowChildrenCount, columnChildrenCount) }} src='/assets/icons/useful/duplicate.svg' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img onClick={(e) => { e.stopPropagation(); this.doRemoveElement(e, section, parents,) }} src='/assets/icons/useful/trash-o.svg' height={14} className="builder-options-icon invert  " />

                                    <div className='mx-2' style={{ height: 16, width: 1, backgroundColor: '#00000050' }}>
                                    </div>
                                    <img src='/assets/icons/useful/row.png' height={14} className="builder-options-icon invert  mrd-2" />
                                    <img src='/assets/icons/useful/column.png' height={14} className="builder-options-icon invert  mrd-2" />

                                </div>
                            </div>
                        )} */}
                        {/* <p>Text</p> */}
                        {/* {console.log('ssssssen:',section)} */}

                        {/* <p>{section.type}</p> */}
                        {/* {console.log(fullData)} */}
                        {Component && (
                            <div className='builder-component-container-view w-100 flex-1 d-flex' onClick={(e) => this.componentSelected(e, section)} style={{ border: this.state.selectedSection?.id == section.id ? '1px solid #007aff' : null, }}>
                                {/* {console.log('component::', this.props.componentsInfo, section)} */}

                                <div className='flex-1 w-100 d-flex flex-column' style={{ alignItems: colStyle?.align, }}>
                                    {/* pointerEvents: this.state.selectedSection?.id == section.id ? 'all' : 'none' */}

                                    {/* <Component changeValue={this.changeSection} data={this.state.currentSection} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} /> */}
                                    {/* <p className="text-center text-bold mt-2 mb-2 text-small">{data.title}</p> */}
                                    <Component section={section} changeValue={(key, value, extra) => this.changeSectionValue(key, value, extra, section)} data={data} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} width={this.props.width} params={this.props.params} changeWindowLink={this.props.changeWindowLink} baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null} windowData={this.props.windowData} colors={this.props.colors} changePage={this.props.changePage} pageChangePage={this.props.pageChangePage} applet={this.props.applet} userView={this.props.userView} fullData={fullData} headers={this.props.headers} onClick={this.actionClicked} actionClicked={this.actionClicked} />
                                </div>
                            </div>
                        )}

                        {/* {this.state.isDraging && dropables.map((dropable, dIndex) => {
                            return (
                                <div key={dIndex} className='dragable' onDragOver={(e) => e.preventDefault()} onMouseOver={(e) => this.onMouseOver(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragEnter={(e) => this.onDragEnter(e, [...parents], { id: section.id, type: section.type, information: section.information, parents, position: dropable.key }, dropable.key)} onDragLeave={(e) => this.onDragLeave(e)} style={{ position: 'absolute', zIndex: dropable.zIndex, top: dropable.top, left: dropable.left, bottom: dropable.bottom, right: dropable.right, height: dropable.height, width: dropable.width, backgroundColor: dropable.backgroundColor }}>

                                </div>
                            )
                        })} */}
                    </div>
                )
            }
        }
    }



    render() {

        // console.log(this.props.view?.settings)
        // console.log(this.state.cardElements)

        let media = { xs: "12", sm: '6', md: '4', lg: "3", xl: "20%" }
        let cardsInrow = this.props.view?.settings?.cardsInrow
        if (cardsInrow && typeof cardsInrow == 'object') {

            media = cardsInrow
            // media.md = (100 / Number(this.props.view?.settings?.cardsInrow)) + '%'
        }

        // console.log(this.props.data)

        return (
            <div className='h-100 px-0 pb-2 pt-2 scroll-no-scrollbar w-100' >


                <div className="d-flex flex-wrap m-0 w-100">

                    {(!Array.isArray(this.props.data) || this.props.data.length == 0) && (
                        <div className='flexcc w-100 py-2 flex-column'>
                            <img src='/assets/icons/useful/planet.png' height={50} alt='' />
                            <p className='text-semibold font-size-14'>{translate("Found Nothing")}</p>
                        </div>
                    )}
                    {Array.isArray(this.props.data) && this.props.data?.map((prop, index) => {
                        // let Component = this.props.component
                        // console.log(this.props.col)
                        return (

                            <Responsive className={' d-flex'} key={index} width={this.props.width} media={media} log={true}>
                                <div className={('px-2 mb-4 flex-1 ')}  >

                                    {/* <div className='br-8 flex-column product-view-box bg-white h-100 ' onClick={() => this.actionClicked({ key: 'edit', function: "openEditModal" }, prop, index)}> */}
                                    <div className='br-8 flex-column product-view-box bg-white h-100 ' style={{}}>
                                        {/* <div className='flexcc w-100 position-relative' style={{ paddingTop: "80%", backgroundImage: 'url(' + imageAddress(prop.image) + ')', backgroundPosition: "center", backgroundSize: "cover", borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                                            <img className='w-100 h-100 position-absolute' style={{ objectFit: 'cover' }} src={prop.src} alt="" />
                                        </div> */}
                                        <div className='px-2 mt-2 pt-2 w-100 mb-2'>
                                            {/* <div className=' w-100 '>
                                                {Array.isArray(this.state.content) && this.state.content?.map((div, rIndex) => {
                                                    return (
                                                        this.renderDiv(div, [], null, null, null, prop)
                                                    )
                                                })}
                                            </div> */}
                                            <CardRenderer
                                                page={this.props.page}
                                                automations={this.props.automations}
                                                content={this.state.content}
                                                data={prop}
                                                params={this.props.params}
                                                width={this.props.width}
                                                variables={this.props.variables}
                                                changeWindowLink={this.props.changeWindowLink}
                                                baseUrl={this.props.baseUrl ? [...this.props.baseUrl] : null}
                                                windowData={this.props.windowData}
                                                colors={this.props.colors}
                                                changePage={this.props.changePage}
                                                pageChangePage={this.props.pageChangePage}
                                                applet={this.props.applet}
                                                userView={this.props.userView}
                                                headers={this.props.headers}
                                                functionsHandler={this.props.functionsHandler}
                                                actions={this.props.actions}
                                                currentRecord={this.props.currentRecord}
                                                currentRecordStage={this.props.currentRecordStage}
                                                changeRecordStage={this.props.changeRecordStage}
                                                setCurrentRecordStage={this.props.setCurrentRecordStage}
                                                actionClicked={this.actionClickedInRow}

                                            />


                                            {/* <div className='flexcb my-2 pb-1'>
                                                <span className='text-smaller mrd-4 color'>{translate(`Read More`)}</span>
                                                <img height="12px" src="/images/nexts.png" alt="" />
                                            </div> */}
                                        </div>
                                    </div>
                                    {/* <Component data={prop} schema={this.props.schema} dontShowPrice={this.props.dontShowPrice} background={this.props.background} settings={this.props.settings} /> */}
                                </div>
                            </Responsive>
                        )

                    })}
                </div>

                {(this.state.data?.length === 0 && !this.state.isLoading) && (
                    <div className="w-100 text-center ">

                        {this.state.data?.length === 0 && !this.state.isLoading && (
                            <p style={{ fontSize: 16, color: '#789', marginTop: 20 }}>{translate('found-nothing')}</p>
                        )}


                    </div>
                )}

                {(this.state.isLoading && !this.state.hideLoader) && (
                    <div className="mt-2 d-flex justify-content-center">
                        <CustomLoader isLoading={true} />

                    </div>
                )}


                {/* <DataGrid hideLoader={true} marginBottom={'px-2 mb-4 flex-1'} width={this.props.width} isLoading={this.state.isLoadingData} data={this.state.Blog} component={AllBlog} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '4', lg: "3", xl: "20%" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions }} /> */}
                {/* <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} /> */}
                {/* <div className='container-fluid d-flex flex-wrap'>
                    <Responsive className={'prd-4'} hight="100%" width={this.props.width} media={this.props.col ?? { xs: "12", sm: '3', md: '3', lg: "3", xl: "3" }}>
                        <div style={{ position: 'sticky', top: 10 }}>
                            <AsideBlog ads={this.state.ads} />
                        </div>
                    </Responsive>
                    <Responsive className={'pld-4'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '9', md: '9', lg: "9", xl: "9" }}>
                        <main className='main-content-blog'>
                            <SingleBlogContent blog={this.state.blog} fullUrl={this.state.fullUrl} />
                        </main>
                    </Responsive>
                    <div className='article-blog-container my-3 container-fluid' style={{ textAlign: "center" }}>
                        <h3 style={{ color: '#4f4f4f' }} className='text-big mb-5 fw-600'>{translate(`Latest Articles`)}</h3>
                        <DataGrid hideLoader={true} marginBottom={'px-2 mb-3 flex-1'} width={this.props.width} isLoading={this.state.isLoadingData} data={this.state.blogs} component={SliderBlog} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '4', lg: "3", xl: "20%" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions }} />
                    </div>
                </div> */}
            </div>
        )
    }
}
{/* <SliderBlog blogs={this.props.allBlogs?.info} fullUrl={this.state.fullUrl} /> */ }
